import { match } from 'ts-pattern';

export type PropsLeague =
  'nfl' | 'nba' | 'mlb' | 'nhl' | 'pga' | 'ncaaf' | 'ncaab' | 'wnba' | 'wc' | 'epl';

// Soccer-family league aliases. `state.type === 'soccer'` is the sport-family
// discriminator from BE; the `league` field itself is competition-specific
// (e.g., 'wc' for World Cup, 'epl' for English Premier League). Add new
// soccer competitions here as the BE adds them.
export const SOCCER_LEAGUE_ALIASES = ['wc', 'epl', 'mls'] as const;
export type SoccerLeagueAlias = (typeof SOCCER_LEAGUE_ALIASES)[number];

export function isSoccerLeague(league: string | undefined): league is SoccerLeagueAlias {
  return SOCCER_LEAGUE_ALIASES.some((alias) => alias === league);
}

export type LeagueFormat = 'team' | 'tournament';

export type TournamentLeague = 'pga';

export const TOURNAMENT_LEAGUES: ReadonlySet<PropsLeague> = new Set<PropsLeague>(['pga']);

export function isTournamentLeague(league: PropsLeague): boolean {
  return TOURNAMENT_LEAGUES.has(league);
}

export function getLeagueFormat(league: string): LeagueFormat {
  return match(league)
    .with('pga', () => 'tournament' as const)
    .otherwise(() => 'team' as const);
}
